import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import Translation from '../../i18n/Translation';
import { confirm as confirmAction, reject as rejectAction } from '../../transfer/actions';
import { getPayoutToTransfer } from '../../transfer/selectors';

export const SlipTransferConfirm = ({ totalPayout, confirm, reject }) => (
  <div className="modal">
    <h2 className="modal__header">
      <Translation section="transfer" label="modalTitle" />
    </h2>
    <p className="modal__paragraph">
      <Translation section="transfer" label="allReturnsInfo" /><br />
      <Translation section="transfer" label="totalReturns" variables={{ totalPayout }} />
    </p>
    <div className="modal__button-line">
      <Button className="modal__button" onClick={confirm}>
        <Translation section="common" label="ok" />
      </Button>
      <Button className="modal__button" onClick={reject}>
        <Translation section="common" label="cancel" />
      </Button>
    </div>
  </div>
);

SlipTransferConfirm.propTypes = {
  totalPayout: PropTypes.string.isRequired,
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  totalPayout: getPayoutToTransfer(state)
});
const mapDispatchToProps = {
  confirm: confirmAction,
  reject: rejectAction
};

export default connect(mapStateToProps, mapDispatchToProps)(SlipTransferConfirm);
